import React from "react";
import { Link } from "react-router-dom";
import site from "../data/site";
import services from "../data/services";

const Footer = () => (
  <footer className="site-footer">
    <div className="container">
      <div className="grid">
        <div className="brand-block">
          <img src="/brand/atlas-logo.png" alt={site.brand} className="footer-logo" />
          <p>{site.shortPitch}</p>
        </div>

        <div>
          <h5>Services</h5>
          {services.slice(0, 6).map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`}>{s.title}</Link>
          ))}
        </div>

        <div>
          <h5>More</h5>
          {services.slice(6).map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`}>{s.title}</Link>
          ))}
        </div>

        <div>
          <h5>Company</h5>
          <Link to="/about">About</Link>
          <Link to="/services">All services</Link>
          <Link to="/contact">Contact</Link>
          <a href={`mailto:${site.contact.email}`}>{site.contact.email}</a>
        </div>
      </div>

      <div className="copy">
        <span>© {new Date().getFullYear()} {site.brand}. All rights reserved.</span>
        <span>{site.location.city}, {site.location.country}</span>
      </div>
    </div>
  </footer>
);

export default Footer;
